<script setup lang="ts">
import ExpandIcon from '@/assets/images/svg/expand.svg?component';

const props = defineProps<{
  title: string;
  testingMethodText: 'sast' | 'dast';
  expanded: boolean;
  accordionClassNames?: string;
}>();

const emit = defineEmits<{ (e: 'toggle', isExpanded: boolean): void }>();

function toggleExpanded() {
  emit('toggle', !props.expanded);
}
</script>

<template>
  <div>
    <div
      class="tw:flex tw:items-center tw:gap-3 tw:cursor-pointer tw:select-none tw:transition-opacity tw:duration-200 hover:tw:opacity-80"
      @click="toggleExpanded"
    >
      <div class="tw:max-w-6">
        <ExpandIcon
          class="tw:text-ghost tw:transition-transform tw:duration-300 tw:shrink-0"
          :class="{ 'tw:rotate-180': expanded }"
        />
      </div>

      <span class="tw:typography-h2">{{ title }}</span>

      <span
        class="tw:typography-sidenotes tw:uppercase tw:text-main-blue tw:bg-blue-bg tw:rounded-full tw:px-3 tw:py-1.5 tw:shrink-0 tw:leading-none"
      >
        {{ testingMethodText
        }}<span v-if="testingMethodText === 'dast'" class="tw:normal-case"> (beta)</span>
      </span>

      <div class="tw:flex-1 tw:h-px tw:bg-[#e3e6ed]"></div>
    </div>

    <div v-if="expanded" :class="accordionClassNames" class="tw:pl-4 tw:pt-6 tw:max-sm:-mr-4">
      <slot />
    </div>
  </div>
</template>
